module.exports = __webpack_public_path__ + "static/media/modal_banner.bffec273.png";